import Swiper, { Navigation, Pagination } from "swiper";

const selectors = {
  mainTarget: '.meganav-products-slider',
};

export default () => {

  function sliderRender() {
    const mainTarget = selectors.mainTarget;
    const mainTargetNode = document.querySelector(mainTarget);

    if (!mainTargetNode) { return }

    Swiper.use([Navigation, Pagination]);
    new Swiper(mainTarget, {
      slidesPerView: 3,
      zoom: false,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      spaceBetween: 0,
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  /**
   * Set Event Bus listeners
   * These are normal trigger from other JS events.
   */
  function setEvenBustListeners() {
    Karmoon.EventBus.listen('ShowMega:open', () => {
      sliderRender();
    });
  }

  function init() {
    sliderRender();
    setEvenBustListeners();
  }

  /**
   * Public interface.
   */
  return Object.freeze({
    init,
  });
};
